<template>
  <div>
    <div>
      <el-row>
        <el-col :span="20">
          <h1 class="logo">
            <img src="../assets/qclogo.png" height="65"/>
          </h1>
        </el-col>
        <el-col :span="4" class="text-a-r">
          <el-dropdown size="small" @command="userMenu">
                    <span class="el-dropdown-link">
                        您好 / {{ userName }}
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-if="perm.indexOf('ma:update') > -1" icon="el-icon-key"
                                command="changePwd">修改密码
              </el-dropdown-item>
              <el-dropdown-item icon="el-icon-switch-button" command="outLogin">退出登陆</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>
      </el-row>
    </div>
    <div class="container">
      <div class="menu">
        <el-menu
            :default-active="curPath"
            class="el-menu-vertical-demo"
            background-color="#545c64"
            text-color="#fff"
            active-text-color="#ffd04b"
            :router="true">
          <el-menu-item index="/welcome">
            <i class="el-icon-s-home"></i>
            <span slot="title">首页</span>
          </el-menu-item>
          <el-menu-item v-if="perm.indexOf('stu:select') > -1" index="/main/students">
            <i class="el-icon-user"></i>
            <span slot="title">学生管理</span>
          </el-menu-item>
          <el-menu-item v-if="perm.indexOf('classroom:select') > -1" index="/main/classroom">
            <i class="el-icon-school"></i>
            <span slot="title">班级管理</span>
          </el-menu-item>
          <el-menu-item v-if="perm.indexOf('course:select') > -1" index="/main/course">
            <i class="el-icon-notebook-1"></i>
            <span slot="title">课程管理</span>
          </el-menu-item>
          <el-menu-item v-if="perm.indexOf('video:select') > -1" index="/main/video">
            <i class="el-icon-video-camera"></i>
            <span slot="title">视频管理</span>
          </el-menu-item>
          <el-menu-item v-if="perm.indexOf('employment:select') > -1" index="/main/employment">
            <i class="el-icon-money"></i>
            <span slot="title">招聘管理</span>
          </el-menu-item>
          <el-menu-item v-if="perm.indexOf('testpaper:select') > -1"  index="/main/testPaper">
            <i class="el-icon-document"></i>
            <span slot="title">试卷管理</span>
          </el-menu-item>
          <el-menu-item v-if="perm.indexOf('topic:select') > -1" index="/main/testQuestions">
            <i class="el-icon-s-order"></i>
            <span slot="title">考题管理</span>
          </el-menu-item>
          <el-menu-item v-if="perm.indexOf('score:select') > -1" index="/main/score">
            <i class="el-icon-medal"></i>
            <span slot="title">成绩管理</span>
          </el-menu-item>
          <!--<el-menu-item @click.native="$message.error('数据不足，无法展示统计图表')">
              <i class="el-icon-data-analysis"></i>
              <span slot="title">学时统计</span>
          </el-menu-item>-->
        </el-menu>
      </div>
      <div class="question">
        <el-page-header @back="goBack" :content="$route.meta.title">
        </el-page-header>
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"/>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"/>
      </div>
    </div>
    <el-dialog v-if="perm.indexOf('ma:update') > -1" width="40%" title="修改管理员密码" :visible.sync="dialogFormVisible"
               :lockScroll="false">
      <el-form ref="changePwdForm" :rules="rules" :model="form" :label-position="'right'"
               label-width="100px">
        <el-form-item label="手机号">
          <el-input v-model="form.mobile" :disabled="true" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="原密码" prop="oldPwd">
          <el-input show-password v-model="form.oldPwd" placeholder="登录所用的密码"
                    autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPwd">
          <el-input show-password v-model="form.newPwd" placeholder="新密码最好是字母+数字+特殊字符"
                    autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="新密码确认" prop="confirmPwd">
          <el-input show-password v-model="form.confirmPwd" placeholder="再一次输入密码"
                    autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelForm">取 消</el-button>
        <el-button type="primary" @click="confirmForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Main",
  data() {
    // 自定义验证，两次密码不一致
    let pwdEqual = (rule, value, callback) => {
      if (this.form.newPwd !== this.form.confirmPwd) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      apiUrl: process.env.VUE_APP_URL + "ma/",
      userName: localStorage.getItem("userName"),
      dialogFormVisible: false,
      form: {
        mobile: localStorage.getItem("userName"),
        oldPwd: '',
        newPwd: '',
        confirmPwd: ''
      },
      perm: localStorage.getItem('perm').split(","),
      rules: {
        oldPwd: [
          {required: true, message: '请输入原密码', trigger: 'blur'}
        ],
        newPwd: [
          {required: true, message: '请输入新密码', trigger: 'blur'}
        ],
        confirmPwd: [
          {required: true, message: '请输入新密码确认', trigger: 'blur'},
          {validator: pwdEqual, trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    userMenu(cmd) {
      if (cmd === 'changePwd') {
        this.dialogFormVisible = true;
      } else if (cmd === 'outLogin') {
        this.outLogin();
      }
    },
    cancelForm() {
      this.dialogFormVisible = false;
      this.$refs['changePwdForm'].resetFields();
    },
    outLogin() {
      localStorage.setItem("token", "");
      this.$router.push('/');
    },
    confirmForm() {
      this.$refs['changePwdForm'].validate((valid) => {
        if (valid) {
          this.$axios.post(
              this.apiUrl + 'changePwd',
              this.form
          ).then(response => {
            let statusCode = response.data.code;
            if (statusCode === 200) {
              this.$message.success('密码修改成功，请重新登录');
              this.outLogin();
            } else if (statusCode === 212) {
              this.$message.error('用户名或密码错误，修改失败');
            }
          });
        } else {
          return false;
        }
      });
    }
  },
  computed: {
    //二级功能页面，也能选中菜单
    curPath() {
      return this.$route.path.split('/').splice(0, 3).join("/");
    }
  }
}
</script>

<style scoped>
.el-page-header {
  color: #909399;
  padding: 20px;
}

.el-menu {
  border: 0;
  padding: 20px 0;
}

.el-menu-item {
  height: 30px;
  line-height: 30px;
}

.text-a-r {
  text-align: right;
  padding: 20px 15px 0 0;
}

.container {
  display: flex;
  min-height: calc(100vh - 65px);
}

.menu {
  min-width: 200px;
  background: #545c64;
  /*height: 100%;*/
}

.question {
  flex: 1;
  background: #f8f8f8;
  /*height: 100%;*/
}

.logo {
  height: 65px;
  line-height: 65px;
  color: #898989;
  padding-left: 10px;
}

.dialog-title {
  color: #3f3f3f;
  font-weight: bold;
}
</style>